import { Component } from '@angular/core';
import { Notification, NotificationService } from '../../../services/notification.service';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-notification',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './notification.component.html',
  styleUrls: ['./notification.component.css']
})
export class NotificationComponent {
  notification: Notification | null = null;
  private hideTimeout: any;

  constructor(private notificationService: NotificationService) {}

  ngOnInit() {
    this.notificationService.notification$.subscribe((notification) => {
      this.notification = notification;

      if (this.hideTimeout) {
        clearTimeout(this.hideTimeout);
      }

      this.hideTimeout = setTimeout(() => {
        this.notification = null;
      }, 5000);
    });
  }

  close() {
    this.notification = null;
    if (this.hideTimeout) {
      clearTimeout(this.hideTimeout);
    }
  }

}
